import React from 'react';
import { ScaleLoader } from 'react-spinners';
import styled from 'styled-components';

const SweetLoading = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: ${(props) => (props.$loading ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  background-color: hsla(0, 100%, 0%, 0.4);
  animation: opacity 1s;
  opacity: 1;
  z-index: 5;
  ${(props) => props.styles}
`;

const LittleSweetLoading = styled.div`
  position: absolute;
  display: ${(props) => (props.$loading ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  animation: opacity 1s;
  background-color: hsla(0, 100%, 0%, 0.2);
  opacity: 1;
  z-index: 5;
  border-radius: 4px;
`;

const Spinner = (props) => {
  return props.little ? (
    <LittleSweetLoading $loading={props.loading}>
      <ScaleLoader loading sizeUnit={'px'} size={200} color={'#e25d34'} />
    </LittleSweetLoading>
  ) : (
    <SweetLoading $loading={props.loading} styles={props.styles}>
      <ScaleLoader loading sizeUnit={'px'} size={500} color={'#e25d34'} />
    </SweetLoading>
  );
};

export default Spinner;
